import { Link, useLocation, useParams } from "react-router-dom";
import { useGetRoomByIdQuery } from "../services/rooms.service";
import { RoomInfo } from "../components/room-info";
import PageLoading from "src/components/pageLoading";
import { appendSearchToPath } from "src/customHooks/usePaginatedTableSearchParams";

const ShowRoom = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const backToRooms = appendSearchToPath("/rooms", location.search);
  const { data, isSuccess, isLoading } = useGetRoomByIdQuery(id!, { skip: !id });

  if (isLoading) {
    return <PageLoading />;
  }

  if (!isSuccess || !data) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Room Not Found</h2>
          <p className="text-gray-600">The room you're looking for doesn't exist.</p>
          <Link to={backToRooms} className="mt-4 inline-flex rounded-lg bg-blue-600 px-4 py-2 text-white no-underline">
            Back to Rooms
          </Link>
        </div>
      </div>
    );
  }

  return <RoomInfo data={data} />;
};

export default ShowRoom;
